/* scanSettingsFileSection.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const scanSettingsFileSectionComponent = {
  template: require('./scanSettingsFileSection.html'),
  controllerAs: 'vm',
  bindings: {},
  controller: class scanSettingsFileSectionController {
    /* @ngInject */
    constructor(commonService, sessionDataService, scanService, moment, $state) {
      this.commonService = commonService
      this.sessionDataService = sessionDataService
      this.scanService = scanService
      this.moment = moment
      this.$state = $state
    }
    async $onInit() {
      this.screenSize = this.commonService.getScreenSize()
      this.scanService.date = moment()
      this.date = this.scanService.date
      this.scanFolder = this.sessionDataService.scanFolder
      await this.scanService.setDefaultCategory()
      this.commonService.updateView()
    }
    openSelectDate() {
      this.selectDate = true
    }
    async calendarClosed() {
      await this.commonService.updateView()
      this.scanService.date = this.date
      this.selectDate = false
       this.commonService.updateView()
    }
    calendarCancel() {
      this.selectDate = false
      this.commonService.updateView()
    }
    getFormattedDate() {
      return this.scanService.date.format('MM-DD-YYYY')
    }
    changeDestination() {
      this.sessionDataService.lastOp = 'scanSettings'
      this.$state.go('scan')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/components/scanSettingsFileSection.component.js